export type MedcallAccess = 'none' | 'access' | 'full';
type MedcallPermissionUser = { policies?: unknown; permissions?: unknown };

export const MEDCALL_EXPLICIT_POLICIES = ['tools:medcall:access:~user', 'tools:medcall:access:~full'];

// Intentionally exact: admin, wildcard, group names and legacy flags do not grant MedCall.
export const getMedcallAccess = (user: MedcallPermissionUser | null | undefined): MedcallAccess => {
  if (!user) return 'none';
  const permissions = [
    ...(Array.isArray(user.policies) ? user.policies : []),
    ...(Array.isArray(user.permissions) ? user.permissions : []),
  ];
  if (permissions.includes('tools:medcall:access:~full')) return 'full';
  if (permissions.includes('tools:medcall:access:~user')) return 'access';
  return 'none';
};

export const isMedcallPath = (path: unknown) => typeof path === 'string' && /^\/tools\/medcall(?:2)?(?:\/|$)/.test(path);
